export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13816.5de9296a.jpg";